/**
 * <s-search-restore> — Suchfelder zeigen einen lesbaren Suchbegriff, während die
 * ausgeführte Suchanfrage davon abweichen kann (Reifenfinder-Syntax, Anführungszeichen).
 * Ohne dieses Element würde ein erneutes Absenden des unangetasteten Feldes den
 * lesbaren Begriff als normale Suche ausführen und die ursprüngliche Anfrage verlieren.
 *
 * Verhalten: Beim Submit ersetzt das Element den q-Wert im FormData durch die
 * ursprüngliche Anfrage, solange das Feld unangetastet ist. Hat der Kunde den
 * Begriff geändert, bleibt seine Eingabe stehen und es läuft eine normale Suche
 * mit dem geänderten Text. Das sichtbare Feld wird nie verändert — es zeigt
 * weiterhin den lesbaren Begriff, auch nach teilweisem Neuladen der Ergebnisse.
 *
 * Attributes (on <s-search-restore>):
 *   data-raw-query     — Die ursprüngliche Suchanfrage (search.terms).
 *   data-display-query — Der lesbare Suchbegriff, der im Feld steht.
 */
class SearchRestore extends HTMLElement {
  #form = null;
  #onFormdata = null;

  connectedCallback() {
    this.#form = this.closest('form');
    if (!this.#form) return;
    this.#onFormdata = (event) => {
      const rawQuery = this.dataset.rawQuery || '';
      const displayQuery = this.dataset.displayQuery || '';
      if (!rawQuery || rawQuery === displayQuery) return;
      const input = this.#form.querySelector('input[name="q"]');
      if (input && input.value === displayQuery) event.formData.set('q', rawQuery);
    };
    this.#form.addEventListener('formdata', this.#onFormdata);
  }

  disconnectedCallback() {
    if (this.#form && this.#onFormdata) {
      this.#form.removeEventListener('formdata', this.#onFormdata);
    }
  }
}

if (!customElements.get('s-search-restore')) {
  customElements.define('s-search-restore', SearchRestore);
}
